import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { EncryptionService } from './encryption.service';
import { BrowserStorageService } from './browser-storage.service';
import { Observable, BehaviorSubject, throwError } from 'rxjs';
import { catchError, finalize, map, tap } from 'rxjs/operators';
import { Router } from '@angular/router';




@Injectable({
  providedIn: 'root'
})
export class RefreshTokenService {
  
  REFRESH_ENDPOINT: string = `${environment.apiUrl}/api/users/auth/refresh/`;

  private http = inject(HttpClient);
  private storage = inject(BrowserStorageService);
  private encryption = inject(EncryptionService);
  private router = inject(Router);

  // BehaviorSubject para manejar si el refresco está en curso.
  // Es clave para evitar llamadas concurrentes al endpoint de refresh.
  isRefreshing$ = new BehaviorSubject<boolean>(false);
  
  private tokenSubject$ = new BehaviorSubject<string | null>(null);
  

  // Observable público que el interceptor puede usar para verificar el estado
  public get isRefreshing(): Observable<boolean> {
    return this.isRefreshing$.asObservable();
  }

  // Observable público que el interceptor usa para esperar el nuevo token
  public get tokenSubject(): Observable<string | null> {
    return this.tokenSubject$.asObservable();
  }

  constructor() {
    this.tokenSubject$.next(this.getAccessToken());
  }
  

  public refreshAccessToken(refreshToken: string | null): Observable<string> {
    const headers = new HttpHeaders({
      'Skip-Auth-Interceptor': 'true' // El valor puede ser 'true' o cualquier string que tu interceptor espere
    });

    return this.http.post<any>(
      `${this.REFRESH_ENDPOINT}`, 
      { refresh: refreshToken }, 
      { headers } // Se pasa como tercer parámetro
    )
  }

  /**
   * Obtiene el Access Token actual (para uso del interceptor y otros componentes).
   */
  public getAccessToken(): string | null {
    const encryptedAccess = this.storage.getSessionStorageItem('access');
    try {
      return encryptedAccess ? this.encryption.decrypt(encryptedAccess) : null;
    } catch {
      return null;
    }
  }

  /**
   * Guarda los tokens y la marca de tiempo.
   */
  private saveTokens(accessToken: string, refreshToken: string | undefined): void {


    // Guardar Access Token y la marca de tiempo
    const encryptedAccess = this.encryption.encrypt(accessToken);
    this.storage.setSessionStorageItem('access', encryptedAccess);

    const timestamp = Math.floor(Date.now() / 1000).toString();
    this.storage.setSessionStorageItem('access_saved_at', timestamp);
    

    // Opcional: Si tu API rota el refresh token, guárdalo aquí también
    if (refreshToken) {
      const encryptedRefresh = this.encryption.encrypt(refreshToken);
      this.storage.setSessionStorageItem('refresh', encryptedRefresh);
    }
  }

  /**
   * Limpia los tokens y redirige al login.
   */
  private logoutAndRedirect(): void {
    this.storage.removeSessionStorageItem('access');
    this.storage.removeSessionStorageItem('refresh');
    this.storage.removeSessionStorageItem('access_saved_at');
    this.tokenSubject$.next(null); // Notificar que ya no hay token
    this.router.navigate(['/login']);
  }

}
